(() => {
  if (!customElements.get('fxl-home-discover')) {
    customElements.define('fxl-home-discover', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const bar = this.querySelector('[data-fxlh-tabs]');
        const tabs = [...this.querySelectorAll('[data-fxlh-tab]')];
        const panels = [...this.querySelectorAll('[data-fxlh-panel]')];
        if (!tabs.length) return;
        const show = tab => {
          tabs.forEach(button => {
            const active = button === tab;
            button.setAttribute('aria-selected', String(active));
            button.tabIndex = active ? 0 : -1;
          });
          panels.forEach(panel => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
        };
        bar.setAttribute('role', 'tablist');
        tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          tab.addEventListener('click', () => show(tab), { signal });
          tab.addEventListener('keydown', event => {
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
            if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = tabs.length - 1;
            if (next === undefined) return;
            event.preventDefault(); show(tabs[next]); tabs[next].focus();
          }, { signal });
        });
        panels.forEach(panel => { panel.setAttribute('role', 'tabpanel'); panel.tabIndex = 0; });
        document.addEventListener('shopify:block:select', event => {
          if (!this.contains(event.target)) return;
          const panel = event.target.closest('[data-fxlh-panel]');
          const tab = tabs.find(button => button.getAttribute('aria-controls') === panel?.id);
          if (tab) show(tab);
        }, { signal });
        bar.hidden = false; this.classList.add('is-enhanced'); show(tabs[0]);
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    });
  }
  if (!customElements.get('fxl-home-collage')) {
    customElements.define('fxl-home-collage', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const on = (element, name, fn) => element.addEventListener(name, fn, { signal });
        let active, timer, touched = false;
        const close = () => {
          clearTimeout(timer);
          this.querySelectorAll('.fxlh-spot__card').forEach(card => { card.hidden = true; });
          this.querySelectorAll('.fxlh-spot__dot').forEach(dot => dot.setAttribute('aria-expanded', 'false'));
          active = null;
        };
        const open = dot => {
          clearTimeout(timer);
          if (active === dot) return;
          const area = dot.closest('.fxlh-theme__media');
          const card = [...area.querySelectorAll('.fxlh-spot__card')].find(item => item.id === dot.getAttribute('aria-controls'));
          if (!card) return;
          close(); active = dot; card.hidden = false; dot.setAttribute('aria-expanded', 'true');
          const box = area.getBoundingClientRect(), point = dot.getBoundingClientRect();
          const width = card.offsetWidth, height = card.offsetHeight, gap = 10, margin = 8;
          const x = point.left - box.left, y = point.top - box.top;
          const cx = x + point.width / 2, cy = y + point.height / 2;
          const dots = [...area.querySelectorAll('.fxlh-spot__dot')].map(item => item.getBoundingClientRect());
          const choices = [[cx - width / 2, y - height - gap], [cx - width / 2, y + point.height + gap], [x + point.width + gap, cy - height / 2], [x - width - gap, cy - height / 2]].map(([left, top]) => {
            left = Math.max(margin, Math.min(left, box.width - width - margin));
            top = Math.max(margin, Math.min(top, box.height - height - margin));
            const overlap = dots.reduce((sum, p) => sum + Math.max(0, Math.min(left + width, p.right - box.left + gap) - Math.max(left, p.left - box.left - gap)) * Math.max(0, Math.min(top + height, p.bottom - box.top + gap) - Math.max(top, p.top - box.top - gap)), 0);
            return {left, top, overlap};
          }).sort((a, b) => a.overlap - b.overlap);
          card.style.left = `${choices[0].left}px`; card.style.top = `${choices[0].top}px`;
        };
        on(this, 'pointerover', event => { if (event.pointerType === 'touch') return; const dot = event.target.closest('.fxlh-spot__dot'); if (dot) open(dot); });
        on(this, 'pointerout', event => {
          if (event.pointerType === 'touch') return;
          const area = active?.closest('.fxlh-theme__media');
          if (!area || area.contains(event.relatedTarget)) return;
          timer = setTimeout(() => { if (!area.contains(document.activeElement)) close(); }, 200);
        });
        on(this, 'pointerdown', event => { touched = event.pointerType === 'touch'; });
        on(this, 'focusin', event => { const dot = event.target.closest('.fxlh-spot__dot'); if (dot && !touched) open(dot); });
        on(this, 'focusout', event => { const area = active?.closest('.fxlh-theme__media'); if (area && !area.contains(event.relatedTarget) && !area.matches(':hover')) close(); });
        on(this, 'click', event => {
          const dot = event.target.closest('.fxlh-spot__dot');
          if (dot && touched && active !== dot) { event.preventDefault(); open(dot); }
          touched = false;
        });
        on(document, 'click', event => { if (!event.target.closest('.fxlh-theme__media')) close(); });
        on(document, 'keydown', event => { if (event.key === 'Escape' && active) { const dot = active; close(); dot.focus({preventScroll:true}); close(); } });
        on(window, 'resize', close);
        this.closeSpots = close;
      }
      disconnectedCallback() { this.closeSpots?.(); this.controller?.abort(); this.controller = null; }
    });
  }
})();
